<script>
    import Fa from "svelte-fa";
    import { faRepeat } from "@fortawesome/free-solid-svg-icons";

    export let specialDays;
    specialDays = specialDays??{};

    const currentYear = new Date().getFullYear();

    function formatTime (hhmm) {
        if (!(typeof hhmm == "string")){
            console.warn("Zu formatierende Uhrzeit ist nicht vom Typ String.")
            return;
        }
        return (hhmm.slice(0, 2)+":"+hhmm.slice(2, 4));
    }

    function formatDate (mmdd, year) {
        if (!(typeof mmdd == "string")){
            console.warn("Zu formatierendes Datum ist nicht vom Typ String.")
            return;
        }
        if (year == "annual") {
            return (mmdd.slice(2, 4)+"."+mmdd.slice(0, 2)+"."+currentYear);
        }
        return (mmdd.slice(2, 4)+"."+mmdd.slice(0, 2)+"."+year);
    }
</script>


{#each Object.entries(specialDays) as [day, specialDay]}
    <div class="container">
        <span class="day">{formatDate(day, specialDay.year)}</span>
        {#if specialDay.year=="annual"}
            <span class="icon" title="Jährlich wiederkehrend">
                <Fa icon={faRepeat} />
            </span>
        {/if}
        <div class="periods">
            {#if specialDay.periods.length > 0}
                {#each specialDay.periods as period}
                    <span>{formatTime(period.open?.time)??"--:--"} - {formatTime(period.close?.time)??"--:--"}</span>
                {/each}
            {:else}
                <span class="closed">geschlossen</span>
            {/if}
        </div>
    </div>
{/each}


<style>
    .container {
        display: grid;
        grid-template-columns: [day] 10ch [icon] 2ch [slots] auto [end];
        grid-template-rows: auto;
        padding: 0.5rem 0;
    }

    /* .container:not(:last-of-type) {
        border-bottom: 1px solid #eee;
    } */

    .day {
        grid-area: day;
        align-self: center;
    }

    .icon {
        grid-area: icon;
        align-self: center;
        cursor: default;
    }

    .periods {
        grid-area: slots;
        justify-self: end;
    }

    .periods>span {
        display: block;
        margin: 0.5rem 0;
    }

    .closed {
        grid-area: slots;
        justify-self: end;
        font-style: italic;
    }
</style>